(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dr-nice-news"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-nice-news-blog="true"]').forEach(section => {
      const sectionId = section.dataset.sectionId;
      if (!sectionId) return;
      
      const postsContainer = section.querySelector('#BlogPostsGrid-' + sectionId);
      console.log('[Nice News Blog] Posts container found:', !!postsContainer, 'Selector:', '#BlogPostsGrid-' + sectionId);
      if (!postsContainer) {
        console.warn('[Nice News Blog] Posts container not found, exiting');
        return;
      }
      
      const showAllPosts = section.dataset.showAllPosts === 'true';
      const isTaggedAll = section.dataset.isTaggedAll === 'true';
      const blogHandle = section.dataset.blogHandle || '';
      const blogUrl = section.dataset.blogUrl || '';
      const currentUrl = section.dataset.currentUrl || '';
      
      console.log('[Nice News Blog] Initial check - showAllPosts:', showAllPosts, 'isTaggedAll:', isTaggedAll);
      
      // Use JavaScript for showAllPosts, isTaggedAll, and regular blog pages
      const isRegularBlog = !showAllPosts && !isTaggedAll && blogHandle;
      
      if (!showAllPosts && !isTaggedAll && !isRegularBlog) {
        console.log('[Nice News Blog] Not a blog page, using Liquid rendering');
        return;
      }
      
      console.log('[Nice News Blog] Proceeding with JavaScript article loading', { showAllPosts, isTaggedAll, isRegularBlog });
      
      const showDate = section.dataset.showDate === 'true';
      const showTags = section.dataset.showTags === 'true';
      const categoryBadgeBg = section.dataset.categoryBadgeBg || '#511E84';
      const categoryBadgeText = section.dataset.categoryBadgeText || '#FFFFFF';
      const dateColor = section.dataset.dateColor || '#262D33';
      const titleColor = section.dataset.titleColor || '#262D33';
      const tagColor = section.dataset.tagColor || '#262D33';
      const POSTS_PER_PAGE = 12;
      const categoryPrefix = 'Nice News for';
      const categoryPrefixAlt = 'Nice News For';
      const categoryPrefixLower = 'nice news for';
      
      let cachedArticles = null;
      let currentPage = 1;
      let allArticles = [];
      let isLoading = false;

      function extractCategory(tags, blogHandle) {
        console.log('[Nice News Blog] extractCategory called with tags:', tags, 'blogHandle:', blogHandle);
        
        // First try to get category from tags
        if (tags && Array.isArray(tags) && tags.length > 0) {
          for (let tag of tags) {
            if (!tag) continue;
            const tagLower = tag.toLowerCase();
            if (tagLower.includes(categoryPrefixLower)) {
              // Case-insensitive replacement using regex
              let category = tag
                .replace(new RegExp(categoryPrefix, 'gi'), '')
                .replace(new RegExp(categoryPrefixAlt, 'gi'), '')
                .replace(new RegExp(categoryPrefixLower, 'gi'), '')
                .trim();
              if (category && category.toLowerCase() !== 'all') {
                console.log('[Nice News Blog] Category extracted from tag:', category);
                return category;
              }
            }
          }
        }
        
        // Fallback: extract from blog handle
        if (blogHandle) {
          const handleLower = blogHandle.toLowerCase();
          // Map blog handles to category names
          const categoryMap = {
            'nice-news-for-moms-1': 'MOMS',
            'breastfeeding-moms': 'BREASTFEEDING MOMS',
            'tattoo-aftercare': 'PERSONAL CARE',
            'nice-news-for-hikers-2': 'SPORTS CARE'
          };
          
          if (categoryMap[handleLower]) {
            console.log('[Nice News Blog] Category from map:', categoryMap[handleLower]);
            return categoryMap[handleLower];
          }
          
          // Generic extraction: remove hyphens, capitalize words
          const genericCategory = blogHandle
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
          console.log('[Nice News Blog] Generic category from handle:', genericCategory);
          return genericCategory;
        }
        
        console.warn('[Nice News Blog] No category found for tags:', tags, 'blogHandle:', blogHandle);
        return '';
      }

      function formatDate(dateInput) {
        if (!dateInput) return '';
        
        let date;
        
        // Handle array format (Shopify sometimes returns dates as arrays)
        if (Array.isArray(dateInput)) {
          // Array format: [year, month, day, hour, minute, second, ...]
          if (dateInput.length >= 3) {
            date = new Date(dateInput[0], dateInput[1] - 1, dateInput[2]); // month is 0-indexed in JS
          } else {
            return '';
          }
        } else if (typeof dateInput === 'string') {
          // String format: ISO date string
          date = new Date(dateInput);
        } else if (dateInput instanceof Date) {
          // Already a Date object
          date = dateInput;
        } else {
          // Try to parse as string
          date = new Date(dateInput);
        }
        
        // Validate the date
        if (!date || isNaN(date.getTime())) {
          console.warn('[Nice News Blog] Invalid date:', dateInput);
          return '';
        }
        
        const months = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
        return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
      }

      function renderArticle(article, index) {
        const category = extractCategory(article.tags, article.blog_handle);
        console.log('[Nice News Blog] Article category:', category, 'Blog handle:', article.blog_handle, 'Tags:', article.tags);
        // Category is already uppercase from the mapping, so no need to call toUpperCase()
        const categoryBadge = category ? `<span class="nice-news-blog__post-category" style="background-color: ${categoryBadgeBg}; color: ${categoryBadgeText};">${category}</span>` : '';
        
        const imageUrl = article.image?.url || article.image || null;
        const image = imageUrl ? `<div class="nice-news-blog__post-image">
          <img src="${imageUrl}" alt="${article.title || ''}" class="nice-news-blog__post-img" loading="lazy" />
          ${categoryBadge}
        </div>` : '';
        
        const date = showDate && article.published_at ? `<div class="nice-news-blog__post-date" style="color: ${dateColor};">${formatDate(article.published_at)}</div>` : '';
        
        let tagsHtml = '';
        if (showTags && article.tags && article.tags.length > 0) {
          // Filter out category prefix tags AND "All" tag (case-insensitive)
          const filteredTags = article.tags.filter(tag => {
            const tagLower = tag.toLowerCase();
            return !tagLower.includes(categoryPrefixLower) && tagLower !== 'all';
          });
          const tagCount = Math.min(3, filteredTags.length);
          if (tagCount > 0) {
            tagsHtml = '<div class="nice-news-blog__post-tags">';
            filteredTags.slice(0, tagCount).forEach((tag, idx) => {
              tagsHtml += `<span class="nice-news-blog__post-tag" style="color: ${tagColor};">${tag}</span>`;
              if (idx < tagCount - 1) tagsHtml += ', ';
            });
            tagsHtml += '</div>';
          }
        }

        return `<article class="nice-news-blog__post grid__item">
          <a href="${article.url}" class="nice-news-blog__post-link">
            ${image}
            <div class="nice-news-blog__post-content">
              ${date}
              <h3 class="nice-news-blog__post-title" style="color: ${titleColor};">${article.title || ''}</h3>
              ${tagsHtml}
            </div>
          </a>
        </article>`;
      }

      async function loadArticlesFromSearch(append = false) {
        return new Promise(async (resolve, reject) => {
        console.log('[Nice News Blog] loadArticlesFromSearch called', { append, currentPage, showAllPosts, isTaggedAll, blogHandle });
        
        if (!postsContainer) {
          console.warn('[Nice News Blog] postsContainer not found');
          return;
        }

        if (isLoading) {
          console.log('[Nice News Blog] Already loading, skipping');
          return;
        }

        isLoading = true;
        const loadingEl = section.querySelector('.nice-news-blog__search-loading');
        if (loadingEl) {
          loadingEl.style.display = 'block';
        }
        
        if (!append) {
          postsContainer.classList.add('loading');
          postsContainer.innerHTML = '';
          // Don't reset currentPage here - it's managed by pagination click handlers
          // Only reset on initial load
          if (!cachedArticles) {
            currentPage = 1;
          }
          // Don't clear allArticles if it already has filtered data (from filterArticlesByUrl)
          // Only clear if it's empty or if we're doing a fresh load
          if (allArticles.length === 0) {
            allArticles = [];
          }
        }

        try {
          let fetchedArticles = null;
          
          // If appending (Load More), always use existing allArticles if available
          if (append && allArticles.length > 0) {
            console.log('[Nice News Blog] Load More: Using existing allArticles:', allArticles.length);
            fetchedArticles = allArticles;
          }
          // If allArticles already has filtered data and not appending, use it directly
          else if (allArticles.length > 0 && !append) {
            console.log('[Nice News Blog] Using already filtered articles:', allArticles.length);
            fetchedArticles = allArticles;
          } else {
            // Otherwise, load from cache or script tag
            fetchedArticles = cachedArticles;
            console.log('[Nice News Blog] Using cached articles?', !!cachedArticles, 'Cached count:', cachedArticles?.length || 0);
            
            if (!fetchedArticles || fetchedArticles.length === 0) {
              // For showAllPosts or regular blog pages, get articles from Liquid JSON script tag
              if (showAllPosts || isRegularBlog) {
              const scriptId = 'articles-data-' + sectionId;
              console.log('[Nice News Blog] Looking for script tag with ID:', scriptId);
              const articlesScript = section.querySelector('#' + scriptId);
              console.log('[Nice News Blog] Script tag found:', !!articlesScript);
              
                  if (articlesScript) {
                    try {
                      fetchedArticles = JSON.parse(articlesScript.textContent);
                      console.log('[Nice News Blog] Loaded articles from Liquid JSON:', fetchedArticles.length, 'Mode:', showAllPosts ? 'showAllPosts' : 'regularBlog');
                      // Sort articles by published_at (newest first) since we're iterating by blog
                      fetchedArticles.sort((a, b) => {
                        const dateA = new Date(a.published_at);
                        const dateB = new Date(b.published_at);
                        return dateB - dateA;
                      });
                      if (fetchedArticles.length > 0) {
                        console.log('[Nice News Blog] First article sample:', fetchedArticles[0]);
                      }
                } catch (e) {
                  console.error('[Nice News Blog] Error parsing articles JSON:', e);
                  console.error('[Nice News Blog] JSON content:', articlesScript.textContent.substring(0, 200));
                  fetchedArticles = [];
                }
              } else {
                console.warn('[Nice News Blog] No articles JSON script tag found with ID:', scriptId);
                console.warn('[Nice News Blog] Section ID:', sectionId);
                console.warn('[Nice News Blog] Available script tags:', Array.from(section.querySelectorAll('script[type="application/json"]')).map(s => s.id));
                fetchedArticles = [];
              }
            } else if (isTaggedAll && blogHandle) {
              // For tagged/all pages, use Search API
              const baseUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
              const limit = 50;
              const searchQuery = `blog:${blogHandle}`;
              console.log('[Nice News Blog] Tagged/all mode - blog handle:', blogHandle);
              console.log('[Nice News Blog] Search query:', searchQuery);
              const searchUrl = `${baseUrl}search/suggest.json?q=${encodeURIComponent(searchQuery)}&resources[type]=article&resources[limit]=${limit}&resources[options][unavailable_products]=hide`;
              console.log('[Nice News Blog] Search URL:', searchUrl);

              const response = await fetch(searchUrl);
              console.log('[Nice News Blog] Fetch response status:', response.status, response.ok);
              
              if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.status}`);
              }

              const data = await response.json();
              console.log('[Nice News Blog] API response data:', data);
              console.log('[Nice News Blog] Resources results:', data.resources?.results);
              console.log('[Nice News Blog] Articles array:', data.resources?.results?.articles);
              
              fetchedArticles = data.resources?.results?.articles || [];
              console.log('[Nice News Blog] Articles found:', fetchedArticles.length);
              
              if (fetchedArticles.length > 0) {
                console.log('[Nice News Blog] First article sample:', fetchedArticles[0]);
                fetchedArticles.sort((a, b) => {
                  const dateA = new Date(a.published_at || 0);
                  const dateB = new Date(b.published_at || 0);
                  return dateB - dateA;
                });
                console.log('[Nice News Blog] Articles sorted by date');
              } else {
                console.warn('[Nice News Blog] No articles found in API response');
              }
            } else {
              fetchedArticles = [];
            }
            
              cachedArticles = fetchedArticles;
            }
            
            // Only update allArticles if we fetched new data and allArticles is empty
            if (fetchedArticles && fetchedArticles.length > 0 && allArticles.length === 0) {
              allArticles = fetchedArticles;
            }
          }
          
          // Ensure allArticles is set (use fetchedArticles if allArticles is empty)
          if (!allArticles || allArticles.length === 0) {
            allArticles = fetchedArticles || [];
          }
          
          // Ensure allArticles is sorted by published_at (newest first)
          if (allArticles.length > 0) {
            allArticles.sort((a, b) => {
              const dateA = new Date(a.published_at);
              const dateB = new Date(b.published_at);
              return dateB - dateA; // Newest first
            });
          }

          const maxArticles = allArticles.length;
          console.log('[Nice News Blog] Total articles:', maxArticles, 'Current page:', currentPage, 'Posts per page:', POSTS_PER_PAGE);
          
          // Calculate which articles to show cumulatively (Load More style)
          const articlesToShow = currentPage * POSTS_PER_PAGE;
          const articlesToDisplay = allArticles.slice(0, articlesToShow);
          const hasMore = articlesToShow < maxArticles;
          
          console.log('[Nice News Blog] Articles to display:', articlesToDisplay.length, 'Has more:', hasMore);

          let articlesHtml = '';
          if (articlesToDisplay.length > 0) {
            console.log('[Nice News Blog] Rendering', articlesToDisplay.length, 'articles');
            
            if (append) {
              // Append only the new articles (next 12) with smooth transition
              const startIndex = (currentPage - 1) * POSTS_PER_PAGE;
              const newArticles = allArticles.slice(startIndex, articlesToShow);
              
              newArticles.forEach((article, index) => {
                const articleHtml = renderArticle(article, startIndex + index);
                const tempArticle = document.createElement('div');
                tempArticle.innerHTML = articleHtml;
                const articleElement = tempArticle.querySelector('.nice-news-blog__post');
                
                if (articleElement) {
                  // Set initial state for animation
                  articleElement.style.opacity = '0';
                  articleElement.style.transform = 'translateY(20px)';
                  articleElement.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
                  
                  // Append to container
                  postsContainer.appendChild(articleElement);
                  
                  // Trigger animation with slight stagger for each article
        setTimeout(() => {
                    requestAnimationFrame(() => {
                      articleElement.style.opacity = '1';
                      articleElement.style.transform = 'translateY(0)';
                    });
                  }, index * 50); // 50ms stagger between each article
                }
              });
              
              console.log('[Nice News Blog] Appended', newArticles.length, 'new articles with smooth transition');
            } else {
              // Render all articles from start with smooth transition
              // Clear container first
              postsContainer.innerHTML = '';
              
              // Create articles with fade-in animation
              articlesToDisplay.forEach((article, index) => {
                const articleHtml = renderArticle(article, index);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = articleHtml;
                const articleElement = tempDiv.querySelector('.nice-news-blog__post');
                
                if (articleElement) {
                  // Set initial state for animation
                  articleElement.style.opacity = '0';
                  articleElement.style.transform = 'translateY(30px)';
                  articleElement.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
                  
                  // Append to container
                  postsContainer.appendChild(articleElement);
                  
                  // Trigger animation with stagger for smooth cascade effect
                  setTimeout(() => {
                    requestAnimationFrame(() => {
                      articleElement.style.opacity = '1';
                      articleElement.style.transform = 'translateY(0)';
                    });
                  }, index * 40); // 40ms stagger between each article for smooth cascade
                }
              });
              
              console.log('[Nice News Blog] HTML rendered with smooth transition, length:', articlesToDisplay.length);
            }
            
            // Use Load More button for both showAllPosts and isTaggedAll
            updateLoadMoreButton(hasMore);
          } else {
            console.warn('[Nice News Blog] No articles to display - showing empty state');
            postsContainer.innerHTML = '<div class="nice-news-blog__empty"><p>No articles found</p></div>';
            removeLoadMoreButton();
          }
          
          function updateLoadMoreButton(hasMore) {
            removeLoadMoreButton();
            
            if (hasMore) {
              const loadMoreContainer = document.createElement('div');
              loadMoreContainer.className = 'nice-news-blog__load-more-container';
              loadMoreContainer.innerHTML = `
                <button class="nice-news-blog__load-more-btn" type="button">
                  Load More
                </button>
              `;
              
              const postsWrapper = postsContainer.closest('.nice-news-blog__posts-wrapper');
              if (postsWrapper) {
                postsWrapper.appendChild(loadMoreContainer);
            } else {
                postsContainer.parentElement.appendChild(loadMoreContainer);
              }
              
              const loadMoreBtn = loadMoreContainer.querySelector('.nice-news-blog__load-more-btn');
              loadMoreBtn.addEventListener('click', () => {
                currentPage++;
                console.log('[Nice News Blog] Load More clicked, loading page:', currentPage);
                loadArticlesFromSearch(true); // Append mode - adds next 12 posts
              });
            }
          }
          
          function removeLoadMoreButton() {
            const existingBtn = section.querySelector('.nice-news-blog__load-more-container');
            if (existingBtn) {
              existingBtn.remove();
            }
          }

          if (loadingEl) {
            loadingEl.style.display = 'none';
          }
          postsContainer.classList.remove('loading');
          isLoading = false;
          resolve(allArticles);
        } catch (error) {
          console.error('[Nice News Blog] Error loading articles:', error);
          console.error('[Nice News Blog] Error stack:', error.stack);
          console.error('[Nice News Blog] Error details:', {
            message: error.message,
            name: error.name,
            showAllPosts,
            isTaggedAll,
            blogHandle
          });
          if (!append) {
            postsContainer.innerHTML = '<div class="nice-news-blog__empty"><p>Error loading articles. Please try again.</p></div>';
          }
          removeLoadMoreButton();
          if (loadingEl) {
            loadingEl.style.display = 'none';
          }
          postsContainer.classList.remove('loading');
          isLoading = false;
          reject(error);
        }
        });
      }

      // Store all articles from all blogs for filtering
      let allBlogsArticles = [];
      
      // Filter articles function
      function filterArticlesByUrl(filterUrl) {
        console.log('[Nice News Blog] Filtering articles by URL:', filterUrl);
        console.log('[Nice News Blog] All blogs articles available:', allBlogsArticles.length);
        
        // Reset to first page and clear cache
        currentPage = 1;
        cachedArticles = null;
        allArticles = [];
        
        // Check if it's the "ALL" button
        if (filterUrl.includes('/pages/all-blogs') || filterUrl.includes('/tagged/all')) {
          // Show all articles - try to load from all-articles-data script tag if not already loaded
          if (allBlogsArticles.length === 0) {
            const allArticlesScript = section.querySelector('#all-articles-data-' + sectionId);
            if (allArticlesScript) {
              try {
                allBlogsArticles = JSON.parse(allArticlesScript.textContent);
                // Sort by date
                allBlogsArticles.sort((a, b) => {
                  const dateA = new Date(a.published_at);
                  const dateB = new Date(b.published_at);
                  return dateB - dateA;
                });
                console.log('[Nice News Blog] Loaded all articles from script tag:', allBlogsArticles.length);
              } catch (e) {
                console.error('[Nice News Blog] Error parsing all articles JSON:', e);
                allBlogsArticles = [];
              }
            } else {
              // Fallback: try to load from articles-data script tag (for show_all_posts pages)
              const articlesScript = section.querySelector('#articles-data-' + sectionId);
              if (articlesScript) {
                try {
                  allBlogsArticles = JSON.parse(articlesScript.textContent);
                  allBlogsArticles.sort((a, b) => {
                    const dateA = new Date(a.published_at);
                    const dateB = new Date(b.published_at);
                    return dateB - dateA;
                  });
                  console.log('[Nice News Blog] Loaded all articles from main script tag:', allBlogsArticles.length);
                } catch (e) {
                  console.error('[Nice News Blog] Error parsing articles JSON:', e);
                  allBlogsArticles = [];
                }
              }
            }
          }
          
          if (allBlogsArticles.length > 0) {
            allArticles = [...allBlogsArticles];
            // Ensure articles are sorted by published_at (newest first)
            allArticles.sort((a, b) => {
              const dateA = new Date(a.published_at);
              const dateB = new Date(b.published_at);
              return dateB - dateA; // Newest first
            });
            console.log('[Nice News Blog] Showing all articles:', allArticles.length, '(sorted by date)');
          } else {
            console.warn('[Nice News Blog] No articles available for ALL');
            allArticles = [];
          }
        } else {
          // Extract blog handle from URL
          const urlMatch = filterUrl.match(/\/blogs\/([^\/]+)/);
          if (urlMatch) {
            const targetBlogHandle = urlMatch[1];
            console.log('[Nice News Blog] Filtering by blog handle:', targetBlogHandle);
            
            // Ensure allBlogsArticles is loaded
            if (allBlogsArticles.length === 0) {
              const allArticlesScript = section.querySelector('#all-articles-data-' + sectionId);
              if (allArticlesScript) {
                try {
                  allBlogsArticles = JSON.parse(allArticlesScript.textContent);
                  allBlogsArticles.sort((a, b) => {
                    const dateA = new Date(a.published_at);
                    const dateB = new Date(b.published_at);
                    return dateB - dateA;
                  });
                  console.log('[Nice News Blog] Loaded all articles for filtering:', allBlogsArticles.length);
                } catch (e) {
                  console.error('[Nice News Blog] Error parsing all articles JSON:', e);
                  allBlogsArticles = [];
                }
              }
            }
            
            if (allBlogsArticles.length > 0) {
              // Filter articles by blog handle
              allArticles = allBlogsArticles.filter(article => {
                return article.blog_handle === targetBlogHandle;
              });
              
              // Ensure filtered articles are sorted by published_at (newest first)
              allArticles.sort((a, b) => {
                const dateA = new Date(a.published_at);
                const dateB = new Date(b.published_at);
                return dateB - dateA; // Newest first
              });
              
              console.log('[Nice News Blog] Filtered articles:', allArticles.length, 'from', allBlogsArticles.length, 'total', '(sorted by date)');
            } else {
              console.warn('[Nice News Blog] No articles available for filtering');
              allArticles = [];
            }
          } else {
            console.warn('[Nice News Blog] Could not extract blog handle from URL:', filterUrl);
            allArticles = [];
          }
        }
        
        // Clear the posts container and re-render with filtered articles
        if (postsContainer) {
          postsContainer.innerHTML = '';
        }
        
        // Re-render with filtered articles
        loadArticlesFromSearch(false);
      }
      
      // Update filter button states
      function updateFilterButtons(activeUrl) {
        const filterButtons = section.querySelectorAll('.nice-news-blog__filters-btn');
        const activeBg = section.querySelector('.nice-news-blog__filters-buttons')?.dataset.activeBg || '#511E84';
        const activeText = section.querySelector('.nice-news-blog__filters-buttons')?.dataset.activeText || '#FFFFFF';
        const inactiveBg = section.querySelector('.nice-news-blog__filters-buttons')?.dataset.inactiveBg || '#FFFFFF';
        const inactiveText = section.querySelector('.nice-news-blog__filters-buttons')?.dataset.inactiveText || '#262D33';
        const borderColor = section.querySelector('.nice-news-blog__filters-buttons')?.dataset.borderColor || '#262D33';
        
      filterButtons.forEach(btn => {
          const filterUrl = btn.dataset.filterUrl || btn.getAttribute('href');
          const isAllButton = btn.dataset.buttonType === 'all';
          const isAllPage = activeUrl.includes('/pages/all-blogs') || activeUrl.includes('/tagged/all');
          
          let isActive = false;
          if (isAllButton && isAllPage) {
            isActive = true;
          } else if (!isAllButton) {
            // Normalize URLs for comparison
            const normalizedActive = activeUrl.replace(/\/$/, '');
            const normalizedFilter = filterUrl.replace(/\/$/, '');
            isActive = normalizedActive === normalizedFilter || normalizedActive.includes(normalizedFilter);
          }
          
          // Use requestAnimationFrame for smooth transitions
          requestAnimationFrame(() => {
            if (isActive) {
          btn.classList.add('is-active');
          btn.style.backgroundColor = activeBg;
          btn.style.color = activeText;
          btn.style.borderColor = activeBg;
        } else {
          btn.classList.remove('is-active');
          btn.style.backgroundColor = inactiveBg;
          btn.style.color = inactiveText;
          btn.style.borderColor = borderColor;
        }
          });
      });
    }

      // Initialize filter buttons
      function initFilterButtons() {
        const filterButtons = section.querySelectorAll('.nice-news-blog__filters-btn');
        
        filterButtons.forEach(btn => {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            const filterUrl = this.dataset.filterUrl || this.getAttribute('href');
            console.log('[Nice News Blog] Filter button clicked:', filterUrl);
            
            // Update URL without page reload
            history.pushState({ filterUrl: filterUrl }, '', filterUrl);
            
            // Filter articles
            filterArticlesByUrl(filterUrl);
            
            // Update button states
            updateFilterButtons(filterUrl);
          });
        });
      }

      function loadPosts() {
        console.log('[Nice News Blog] loadPosts called');
        console.log('[Nice News Blog] Section data:', {
          showAllPosts,
          isTaggedAll,
          blogHandle,
          blogUrl,
          currentUrl
        });
        
        if (!postsContainer) {
          console.warn('[Nice News Blog] postsContainer not found in loadPosts');
          return;
        }

        loadArticlesFromSearch(false).then(() => {
          // Store all articles for filtering
          if (allBlogsArticles.length === 0) {
            // Try to load all articles from all blogs script tag (for regular blog pages)
            const allArticlesScript = section.querySelector('#all-articles-data-' + sectionId);
            if (allArticlesScript) {
              try {
                allBlogsArticles = JSON.parse(allArticlesScript.textContent);
                // Sort by published_at (newest first)
                allBlogsArticles.sort((a, b) => {
                  const dateA = new Date(a.published_at);
                  const dateB = new Date(b.published_at);
                  return dateB - dateA;
                });
                console.log('[Nice News Blog] Loaded all articles from all blogs for filtering:', allBlogsArticles.length, '(sorted by date)');
              } catch (e) {
                console.error('[Nice News Blog] Error parsing all articles JSON:', e);
                // Fallback: use current articles
                if (allArticles.length > 0) {
                  allBlogsArticles = [...allArticles];
                  // Ensure sorted
                  allBlogsArticles.sort((a, b) => {
                    const dateA = new Date(a.published_at);
                    const dateB = new Date(b.published_at);
                    return dateB - dateA;
                  });
                  console.log('[Nice News Blog] Stored current articles as fallback:', allBlogsArticles.length, '(sorted by date)');
                }
              }
            } else if (allArticles.length > 0) {
              // If no all-articles script tag, store current articles (for "all posts" page)
              allBlogsArticles = [...allArticles];
              // Ensure sorted
              allBlogsArticles.sort((a, b) => {
                const dateA = new Date(a.published_at);
                const dateB = new Date(b.published_at);
                return dateB - dateA;
              });
              console.log('[Nice News Blog] Stored all articles for filtering:', allBlogsArticles.length, '(sorted by date)');
            }
          }
        }).catch(err => {
          console.error('[Nice News Blog] Error loading posts:', err);
        });
      }

      function handleURLChange() {
        const currentPath = window.location.pathname;
        filterArticlesByUrl(currentPath);
        updateFilterButtons(currentPath);
      }

      window.addEventListener('popstate', handleURLChange);
      
      // Initialize filter buttons
      initFilterButtons();
      
      // Update filter buttons on load
      updateFilterButtons(window.location.pathname);

      loadPosts();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nice-news-blog-filters"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-section-id]');
    if (!section) return;

    const filterButtons = section.querySelectorAll('.nice-news-blog-filters__btn');
    const activeBg = section.dataset.activeBg;
    const activeText = section.dataset.activeText;
    const inactiveBg = section.dataset.inactiveBg;
    const inactiveText = section.dataset.inactiveText;
    const borderColor = section.dataset.borderColor;

    function normalizeUrl(url) {
      if (!url) return '';
      try {
        const urlObj = new URL(url, window.location.origin);
        return urlObj.pathname.replace(/\/$/, '');
      } catch (e) {
        return url.replace(/\/$/, '');
      }
    }

    function updateButtonStates() {
      const currentPath = window.location.pathname;
      const isAllBlogsPage = currentPath.includes('/pages/all-blogs') || currentPath.includes('/tagged/all');
      const isBlogPage = currentPath.includes('/blogs/');
      
      filterButtons.forEach(btn => {
        const buttonType = btn.dataset.buttonType;
        let isActive = false;
        
        if (buttonType === 'all') {
          isActive = isAllBlogsPage;
        } else {
          const buttonUrl = normalizeUrl(btn.dataset.buttonUrl || btn.getAttribute('href'));
          isActive = currentPath === buttonUrl || currentPath.includes(buttonUrl);
        }
        
        if (isActive) {
          btn.classList.add('is-active');
          btn.style.backgroundColor = activeBg;
          btn.style.color = activeText;
          btn.style.borderColor = activeBg;
        } else {
          btn.classList.remove('is-active');
          btn.style.backgroundColor = inactiveBg;
          btn.style.color = inactiveText;
          btn.style.borderColor = borderColor;
        }
      });
    }

    window.addEventListener('popstate', updateButtonStates);
    
    // Update on page load
    updateButtonStates();
  })();

  } catch(e) { console.error(e); }
})();
})();
